import { render, staticRenderFns } from "./Cobrancas.vue?vue&type=template&id=f874f828&scoped=true"
import script from "./Cobrancas.vue?vue&type=script&lang=js"
export * from "./Cobrancas.vue?vue&type=script&lang=js"
import style0 from "./Cobrancas.vue?vue&type=style&index=0&id=f874f828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f874f828",
  null
  
)

export default component.exports